export default __webpack_public_path__ + "static/media/CuotitasLogo.68ed18eb.png";